const CURRENCY_CONVERTER_API_KEY = window.gon.reactCurrencyConverterApiKey

const CACHED_RESULTS = new Map<string, number>()

export const getCurrencyConversionFactor = async (
  fromCurrency: string,
  toCurrency: string,
): Promise<number> => {
  if (fromCurrency === toCurrency) return Promise.resolve(1)
  const memoKey = `${fromCurrency}-${toCurrency}`
  if (CACHED_RESULTS.has(memoKey)) return CACHED_RESULTS.get(memoKey) as number

  const query = fromCurrency + "_" + toCurrency
  const url =
    "https://api.currconv.com/api/v7/convert?q=" +
    query +
    "&compact=ultra&apiKey=" +
    CURRENCY_CONVERTER_API_KEY

  return fetch(url)
    .then(response => response.json())
    .then(data => {
      const result = (data as Record<string, number>)[query]
      CACHED_RESULTS.set(memoKey, result)
      return result
    })
}

export default {
  getCurrencyConversionFactor,
}
